import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "m16.883 12.877.486-3.555H13.64v-2.27c0-1.03.303-1.731 1.866-1.731H17.5V2.14A28.266 28.266 0 0 0 14.595 2C11.72 2 9.75 3.657 9.75 6.7v2.622H6.5v3.555h3.251V22h3.889v-9.123z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }